import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
const MapSection: React.FC = () => {
  const $ = _c(15);
  const intl = useIntl();
  let t0;
  if ($[0] !== intl) {
    t0 = intl.formatMessage({
      id: "contact.whereToFind"
    });
    $[0] = intl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h2 className="text-2xl font-bold text-gray-900 mb-4">{t0}</h2>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== intl) {
    t2 = intl.formatMessage({
      id: "contact.location"
    });
    $[4] = intl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className="text-gray-600">{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className="text-center mb-8">{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      height: "500px"
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="max-w-6xl mx-auto"><div className="bg-white rounded-lg shadow-md overflow-hidden"><div className="w-full" style={t5}><iframe src="https://www.google.com/maps?q=48.6274,14.1697&output=embed&hl=cs" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={"Mapa s um\xEDst\u011Bn\xEDm Salonu F\xE9nix"} /></div></div></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4) {
    t7 = <section className="py-16 bg-gray-50"><div className="container mx-auto px-4">{t4}{t6}</div></section>;
    $[13] = t4;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default MapSection;